import * as React from 'react'
import Tooltip from '@mui/material/Tooltip'
import { PopperProps } from '@mui/material/Popper'

export function withTooltip<T>(WrappedComponent: React.ComponentClass<T> | React.FunctionComponent<T>) {
  const WithTooltip = function (props: T & { title: string, popperProps?: Partial<PopperProps> }) {
    const { title, ...componentProps } = props
    return (
      <Tooltip title={title} PopperProps={props.popperProps}>
        <WrappedComponent {...componentProps as any} />
      </Tooltip>
    )
  }
  WithTooltip.displayName = `Tooltip(${WrappedComponent.displayName || WrappedComponent.name})`
  return WithTooltip
}
